import Vue from 'vue'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import App from './App.vue'
import VueSweetalert2 from 'vue-sweetalert2'
/* eslint-disable no-unused-vars */
import Promise from 'bluebird'
import tinymce from 'vue-tinymce-editor'
import VueCroppie from 'vue-croppie'
import VueTabs from 'vue-nav-tabs'
import 'vue-nav-tabs/themes/vue-tabs.css'
import LightBootstrap from './light-bootstrap-main'
import routes from './routes/routes'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
import BootstrapVue from 'bootstrap-vue'
import VueMask from 'v-mask'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueSanitize from 'vue-sanitize'
import Datetime from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import { Settings } from 'luxon'
import draggable from 'vuedraggable'
import VueCookies from 'vue-cookies'
import VueYouTubeEmbed from 'vue-youtube-embed'
import moment from 'moment'

// plugin setup
require('moment/locale/tr')
Vue.use(VueRouter)
Vue.use(LightBootstrap)
Vue.use(VueResource)
Vue.use(VueMask)

Vue.use(VueSweetalert2)
Vue.use(VueYouTubeEmbed)
Vue.component('tinymce', tinymce)
Vue.component('draggable', draggable)
Vue.use(VueTabs)
Vue.use(VueCroppie)
Vue.use(require('vue-moment'), { moment })
Vue.use(BootstrapVue)
Vue.use(VueSanitize)
Vue.use(Datetime)
Vue.use(VueCookies)
Settings.defaultLocale = 'tr'

const router = new VueRouter({
    routes,
    linkActiveClass: 'nav-item active'
})
Vue.component('icon', Icon)
Vue.mixin({
        methods: {
            mediaURL: function() {
                if (location.protocol + '//' + location.hostname === 'https://panel.buzpateni.org.tr') {
                    return 'https://www.buzpateni.org.tr/uploads/'
                }
                return 'http://buzpateni.sandbox/uploads/'
            },
            raceURL: function() {
                if (location.protocol + '//' + location.hostname === 'https://panel.buzpateni.org.tr') {
                    return 'https://panel.buzpateni.org.tr/api/load-files/'
                }
                return 'http://localhost:8000/api/load-files/'
            },
            licenseURL: function() {
                if (location.protocol + '//' + location.hostname === 'https://panel.buzpateni.org.tr') {
                    return 'https://panel.buzpateni.org.tr/api/set-license/'
                }
                return 'http://localhost:8000/api/set-license/'
            },
            hesURL: function() {
                if (location.protocol + '//' + location.hostname === 'https://panel.buzpateni.org.tr') {
                    return 'https://panel.buzpateni.org.tr/api/set-hes/'
                }
                return 'http://localhost:8000/api/set-hes/'
            },
            pdfURL: function() {
                if (location.protocol + '//' + location.hostname === 'https://panel.buzpateni.org.tr') {
                    return 'https://www.buzpateni.org.tr/uploads/pdf/'
                }
                return 'http://buzpateni.sandbox/uploads/pdf/'
            },
            excelURL: function() {
                if (location.protocol + '//' + location.hostname === 'https://panel.buzpateni.org.tr') {
                    return 'https://www.buzpateni.org.tr/uploads/excel/'
                }
                return 'http://buzpateni.sandbox/uploads/excel/'
            },
            generalURL: function(path) {
                if (location.protocol + '//' + location.hostname === 'https://panel.buzpateni.org.tr') {
                    return 'https://www.buzpateni.org.tr/uploads/' + path + '/'
                }
                return 'http://buzpateni.sandbox/uploads/' + path + '/'
            },
            getCurrentUserDetails() {
                if (localStorage.getItem('CurrentLoggedUserDetails')) {
                    return JSON.parse(localStorage.getItem('CurrentLoggedUserDetails'))
                }
            },
            slugify: function(text) {
                if (!text) {
                    return null
                }
                var trMap = {
                    'çÇ': 'c',
                    'ğĞ': 'g',
                    'şŞ': 's',
                    'üÜ': 'u',
                    'ıİ': 'i',
                    'öÖ': 'o'
                }
                for (var key in trMap) {
                    text = text.replace(new RegExp('[' + key + ']', 'g'), trMap[key])
                }
                return text.replace(/[^-a-zA-Z0-9\s]+/ig, '').replace(/\s/gi, '-').replace(/[-]+/gi, '-').toLowerCase()
            },
            notifier(verticalAlign, horizontalAlign, color, message) {
                const notification = {
                    template: `<span>${message}</span>`
                }
                let icn = null
                if (color === 'success') {
                    icn = 'nc-check-2'
                } else if (color === 'danger') {
                    icn = 'nc-simple-remove'
                } else if (color === 'warning') {
                    icn = 'nc-bell-55'
                } else {
                    icn = 'nc-send'
                }
                this.$notifications.notify({
                    component: notification,
                    icon: `nc-icon ${icn}`,
                    horizontalAlign,
                    verticalAlign,
                    type: color
                })
            },
            toggleLoader() {
                if (document.getElementById('loader').classList.contains('loader-hide')) {
                    document.getElementById('loader').classList.add('loader-show')
                    document.getElementById('loader').classList.remove('loader-hide')
                } else {
                    document.getElementById('loader').classList.add('loader-hide')
                    document.getElementById('loader').classList.remove('loader-show')
                }
            }
        }
    })
    /* eslint-disable no-new */
new Vue({
    el: '#app',
    render: h => h(App),
    router,
    methods: {
        getLimit() {
            if (!localStorage.getItem('filterLimit')) {
                this.$http.get('/api/settings/get/filter_limit').then((response) => {
                    localStorage.setItem('filterLimit', response.body.data)
                    location.reload()
                })
            } else {
                return localStorage.getItem('filterLimit')
            }
        }
    },
    beforeMount() {
        this.getLimit()
    },
    mounted() {
        this.$moment.locale('tr')
    }
})


// WEBPACK FOOTER //
// ./src/main.js